enum OrganizationStoreCustomAttribute
{
    BusinessCategory = 'businesscategory',
    BusinessRegion = 'businessregion',
    BusinessUnit = 'businessunit'
};

export default OrganizationStoreCustomAttribute;